// Copyright (c) 2019 Deere & Company
import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
//import CSVFile from '../../assets/analysis-comments-report.csv';
import FileUploadPanel from './file-upload-panel';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../shared/services/customize-error-alert-bar';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { uploadAnalysisCommentsData } from '../repositories';
// import { Accordion } from 'react-bootstrap';
import _ from 'lodash';
import { downloadSampleReports } from '../../claims/repositories';

class AnalysisCommentsUpload extends Component {

    state = {
        fileInfo: { },
        uploadResp: '',
        uploadStatus: ''
    }

    componentDidMount () {

        this.props.increaseCounter();
        setTimeout( () => {

            this.props.decreaseCounter();

        }, 500 );

    }

    handleFileDrop = files => {

        this.setState( {
            fileInfo: files[0],
        } );

    }

    handleRejectedFiles = () => {

        this.props.increaseCounter();
        const msg = 'Only CSV files are allowed';
        customizeErrorAlert( msg );
        this.props.decreaseCounter();

    }

    handleSubmitClick = () => {
        this.setState( {
            uploadResp: '',
            uploadStatus: ''
        } );

        this.props.increaseCounter();
        uploadAnalysisCommentsData( this.state.fileInfo ).then( response => {

            if ( response.errors.length ) {

                response.errors.forEach( element => {

                    customizeErrorAlert( element );

                } );

            } else {
                console.log("response.status::",response.uploadStatistics);

                this.setState( {
                    uploadResp: response.uploadStatisticsMap,
                    uploadStatus:response.status,
                    unAuthorizedFactoryList:response.unAuthorizedFactoryList,
                } );
                console.log("uploadResp",this.state.uploadResp);
               // this.props.createSuccessMessage( response.status );
            }
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleCancleClick = () => {

        this.setState( {

            fileInfo: { },
            uploadResp: '',
            uploadStatus: '',
            unAuthorizedFactoryList:'',


        } );

    }

     handleDownloadClick = (fileName) => () => {
            console.log("fileName", fileName);
            
            this.props.increaseCounter();
    
            downloadSampleReports(fileName)
                .then(response => {
                    response.blob().then( blob => {
    
                        const url = window.URL.createObjectURL( blob );
                        const a = document.createElement( 'a' );
                        a.setAttribute( 'download', fileName+'.csv' );
                        a.href = url;
                        document.body.appendChild( a );
                        a.click();
                        a.parentNode.removeChild( a );
                
                    } );
                    this.props.decreaseCounter();
                })
                .catch(() => {
                    this.props.decreaseCounter();
                });
        }
    

    render () {
        const containerStyle = {
            // marginTop: '1%',
            // backgroundColor: '#f5f5f5',
            backgroundColor: 'white',
            border: '1px solid black',
            borderStyle: 'dotted',
            borderRadius: '4px',
            paddingLeft: '10px',
            marginLeft: '5px',
            marginRight: '5px',
            fontSize: '14px'
        };

        // const responses= {
        //     'UPDATED RECORDS': '2' ,
        //     'INSERTED RECORDS': '2'
        //
        // }
        // const uploadStatus = "TOTAL UPDATED RECORDS : 100 Out-Off 130 Records."
        const valueStyleStart = {
            width: '2%',
            display: 'inline-block',
        };

        const valueStyleLeft = {
            width: '20%',
            display: 'inline-block',
            fontSize: '12px',
        };
        const valueStyleMiddle = {
            width: '2%',
            display: 'inline-block',
            fontSize: '12px',
            fontWeight:'bold'
        };
        const valueStyleRight = {
            width: '40%',
            display: 'inline-block',
            fontSize: '12px'
        };
        const valueStyleLeftListPP = {
            width: '75%',
            display: 'inline-block',
            fontSize: '12px'
        };
        const valueStyleLeftListContent = {
            width: '5%',
            display: 'inline-block',
            fontSize: '12px'        };
        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <div className="massUpdate-page">
                    <div className="upload-label-analysis">
                        <h2>Analysis Comments Data Upload</h2>
                    </div>
                    {/* <div className="sample-report-analysis">
                        <a title="Field having values can update only" href={CSVFile} download="analysis-comments-report.csv">Download Sample Report</a>
                    </div> */}

                    <div className="sample-report-analysis">
                    <a
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('analysis-comments-report')}
                    >
                        Download Sample Report
                    </a>
                </div>

                    <FileUploadPanel
                        handleFileDrop={this.handleFileDrop}
                        handleRejectedFiles={this.handleRejectedFiles}
                        message={this.state.fileIcon}
                        handleSubmitClick={this.handleSubmitClick}
                        handleCancleClick={this.handleCancleClick}
                        fileName={this.state.fileInfo.name}
                    />

                </div>
                {/*<Accordion*/}
                {/*            accordionId="analysis-comments-upload"*/}
                {/*            title=""*/}
                {/*            isExpanded={false}*/}
                {/*            */}
                {/*        >*/}

                {/*{*/}
                {/*    (!_.isEmpty(this.state.uploadResp)) ?*/}
                {/*        <div style ={{ marginTop : '1%' }}>*/}

                {/*    {*/}
                {/*        this.state.uploadResp.map((item)=>*/}
                {/*       <li><small> {item} </small> </li>*/}
                {/*        )} </div> : null*/}
                {/*}*/}


                {/*<div style={containerStyle}>*/}
                {/*    <b>{uploadStatus} &#9989; </b>*/}
                {/*            {*/}
                {/*        Object.entries(responses).map( ([key, value]) =>*/}
                {/*            <small>*/}
                {/*            <ul>*/}
                {/*                <li style={valueStyleStart}>&#10004;</li>*/}
                {/*                <li style={valueStyleLeft}>{key}</li>*/}
                {/*                <li style={valueStyleMiddle}>:</li>*/}
                {/*                <li style={valueStyleRight}>{value}</li>*/}
                {/*            </ul>*/}
                {/*            </small>*/}
                {/*    )}*/}
                {/*    </div>*/}

                {
                    (!_.isEmpty(this.state.uploadResp)) ?
                        <div style={containerStyle}>
                            <span role="img" aria-label="image">{this.state.uploadStatus} &#9989; </span>
                            {
                                Object.entries(this.state.uploadResp).map( ([key, value]) =>
                                    <small>
                                        <ul>
                                            <li style={valueStyleStart}>&#10004;</li>
                                            <li style={valueStyleLeft}>{key}</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleRight}>{value} Records</li>
                                        </ul>
                                    </small>

                                )} 
                                
                                {
                                (!_.isEmpty(this.state.unAuthorizedFactoryList)) ?
                                    <div>
                                        <hr></hr>
                                        <ul>
                                            <li style={valueStyleStart}>&#9888;</li>
                                            <li style={valueStyleLeft}>UNAUTHORIZED FACTORY</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleLeftListPP}>
                                                {this.state.unAuthorizedFactoryList.length} Records
                                            </li>
                                            <li style={valueStyleStart}></li>
                                            {
                                                this.state.unAuthorizedFactoryList.map((factoryCode) => (
                                                    
                                                    <li style={valueStyleLeftListContent}>&#9733; {factoryCode}</li>
                                                ))}
                                        </ul>

                                    </div> : null
                            }
                                </div> : null
                }

                            {/*</Accordion>*/}
            </section>
        );

    }

}

AnalysisCommentsUpload.displayName = 'AnalysisCommentsUpload';
AnalysisCommentsUpload.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories.factories,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );

export default connect( mapStateToProps, mapDispatchToProps )( AnalysisCommentsUpload );
